"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formField = _interopRequireDefault(require("./form-field"));

require("./text.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Text = function Text(props) {
  var input = props.input,
      meta = props.meta,
      otherProps = _objectWithoutProperties(props, ["input", "meta"]); // eslint-disable-line no-unused-vars


  return /*#__PURE__*/_react["default"].createElement(_formField["default"], _extends({}, otherProps, {
    meta: meta
  }), /*#__PURE__*/_react["default"].createElement("input", _extends({}, otherProps, input)));
};

Text.propTypes = {
  type: _propTypes["default"].oneOf(['text', 'password', 'number']),
  input: _propTypes["default"].object.isRequired,
  // eslint-disable-line
  meta: _formField["default"].propTypes.meta,
  autoComplete: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  label: _formField["default"].propTypes.label,
  className: _formField["default"].propTypes.className
};
Text.defaultProps = {
  type: 'text',
  label: _formField["default"].defaultProps.label,
  meta: _formField["default"].defaultProps.meta,
  className: '',
  autoComplete: null,
  placeholder: null
};
var _default = Text;
exports["default"] = _default;